import React from 'react';
import styled from 'styled-components';
import Icon from './Icon';
import { pascalCase } from '../utility/functions';

const Wrapper = styled.div`
    font-size: 1.5em;
    font-weight: 800;
    text-align: center;
    margin-bottom: 0.67em;
`;
const I = styled(Icon)`
    margin-right: 0.5em;
`;

const Title = ({ children, ...props }) => (
    <Wrapper {...props}>
        {props.icon ? <I icon={props.icon} /> : null}
        {typeof children === 'string' ? pascalCase(children) : children}
    </Wrapper>
);


export default Title;